import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { Plug } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export const Route = createFileRoute("/_auth/connected-systems/")({
  component: ConnectedSystems,
});

function ConnectedSystems() {
  return (
    <>
      <PageHeader title="Connected Systems" />
      <main className="h-full overflow-y-auto bg-slate-100 p-6">
        <EmptyState
          title="Connected Systems"
          description="This page isn't available yet, but it's coming soon. You'll be able to connect herd management systems and other trusted programs directly here. This will simplify data management, making certification applications more seamless and providing deeper insights into your cattle candidate groups."
          Icon={Plug}
        />
      </main>
    </>
  );
}
